import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=461cc37c&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=ts&"
export * from "./UserTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=461cc37c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cc37c",
  null
  
)

component.options.__file = "UserTable.vue"
export default component.exports